import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import ServicesInnerCardsCarousel from '../../component/ServicesInnerCardsCarousel/ServicesInnerCardsCarousel'
import { Helmet } from 'react-helmet'

const cardD = [
  {
    img: false,
    title: "",
    para:'Assessment and imaging.',
    number:"01",
    id: 1,
  },
  {
    img: false,
    title: "",
    para:'Surgical or non-surgical treatment planning.',
    number:"02",
    id: 2,
  },
  {
    img: false,
    title: "",
    para:'Post-treatment rehabilitation.',
    number:"03",
    id: 3,
  },
]

const cardList = [
  {
            link:"/sports-medicine",
        img:"/images/creatives/service-main-1.webp",
    name:" Sports Medicine",
    rank:"",
    para:'Prevention, rehabilitation and performance care for all lifestyles.'
  },
  {
    link:"/naturopathic-medicine",
    img:"/images/creatives/service-main-9.webp",
    name:"Naturopathic Medicine",
    rank:"",
    para:'An integrative approach combining clinical science and natural therapies to optimize health.'
  },
  // {
  //           link:"/mens",
  //       img:"/images/creatives/service-main-11.webp",
  //   name:" Pelvic Floor Therapy – Men",
  //   rank:"",
  //   para:'Targeted treatment for pelvic muscle strength and coordination.'
  // },
]

const boostCardData = [
  "Restore joint and spine function",
  "Reduce pain and inflammation",
  "Regain confidence in movement",
]

const serviceInnerCardData = [
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Orthopaedic Surgery",
    content:"Lorem ipsum dolor sit amet, consectetur ",
  },
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Sports Medicine Rehab",
    content:"Lorem ipsum dolor sit amet, consectetur ",
  },
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Physiotherapy",
    content:"Lorem ipsum dolor sit amet, consectetur ",
  },
  {
    icon:"/images/icons/member-icon-2.png",
    heading:"Pain Management",
    content:"Lorem ipsum dolor sit amet, consectetur ",
  },
]

function OrthopaedicClinic() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Best Orthopaedic Service in Toronto | The Toronto Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/orthopaedic-clinic"
        />
        <meta
          name="description"
          content="Toronto’s best orthopaedic service for joint and bone care. We provide personalized treatment to reduce pain, improve mobility, and enhance your recovery journey."
        ></meta>

      </Helmet>
         <Header/>
        <HomeHero
            heading='Orthopaedic Clinic'
            content='Evidence-based joint, bone, and surgical care for restoring mobility.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/orthopaedichero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
            calendlyType={13}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="Our Orthopaedic Clinic provides advanced diagnosis and treatment for musculoskeletal conditions. From injury to surgery to full recovery, our team supports your entire journey to regain function and reduce pain."
            bgImg="/images/creatives/service-main-10.webp"
          />

          <div className='pt-4'></div>
          {/* <SlideScrollContent
            cardData={cardD}
            noContent={true}
          /> */}
          <BoostshootRowCard
            cards={cardD}
          />
          <div className='pb-5'></div>
        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />


      <ServicesInnerCardsCarousel
        heading='Integrated Modalities'
        para="We combine multiple treatment approaches to ensure every patient gets the most effective plan:"
        cardContent={serviceInnerCardData}
      />
        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph=""
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default OrthopaedicClinic